import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  return (
    <section className="my-20">
      <Helmet>
        <title>Dailysocialboost | Privacy policy</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-10">Privacy Policy</h2>
      <p className="my-5">
        Your privacy is our top priority. We are dedicated to safeguarding your personal information
        and have established this Privacy Policy to explain how we handle, use, and protect your
        data. We use your personal information solely for order fulfillment and assure you that it
        will never be sold or shared with third parties, upholding our commitment to confidentiality
        and privacy.
      </p>
      <h4 className="font-semibold">The Basics</h4>
      <div className="my-5">
        <ul className="list-disc mx-5">
          <li>
            We will clearly state the reasons for collecting personal information at or before the
            time of collection.
          </li>
          <li>
            Personal information is collected and used only for the purposes we specify unless we
            have explicit consent from the individual or are required to do so by law.
          </li>
          <li>
            Personal information is retained only as long as necessary for the fulfillment of those
            specified purposes.
          </li>
          <li>
            We collect personal information lawfully and fairly, with the individual’s consent where
            appropriate.
          </li>
          <li>
            Personal data collected will be relevant, accurate, complete, and up-to-date, as
            required for the purposes it is used.
          </li>
          <li>
            We protect personal information with appropriate security measures against loss, theft,
            unauthorized access, disclosure, copying, use, or modification.
          </li>
          <li>
            We provide clear information to customers regarding our personal information management
            policies and practices.
          </li>
          <li className="font-semibold text-decoration-line: underline">
            Some payment processing is conducted through PayPal’s secure system or other secure
            payment gateways, using SSL encryption. We do not handle sensitive financial information
            on our website.
          </li>
          <li className="font-semibold text-decoration-line: underline">
            We may collect and store limited payment information like card type, expiration date,
            and the last four digits of your payment card number. Full payment card numbers are not
            collected or stored by us but by our third-party payment processor.
          </li>
        </ul>
      </div>

      <h4 className="font-semibold">Use of Information</h4>
      <div className="my-5">
        We utilize your information to:
        <ul className="list-disc mx-5">
          <li>Enhance and personalize our services and marketing efforts.</li>
          <li>Process registrations, orders, and payments.</li>
          <li>Communicate with you regarding these and other topics.</li>
          <li>
            Prevent, detect, and investigate potential illegal activities, including fraud, and
            enforce our terms.
          </li>
          <li>
            Analyze and understand our audience for service improvement (including user interface
            experiences).
          </li>
        </ul>
      </div>

      <h4 className="font-semibold">Disclosure of Information</h4>
      <div className="my-5">
        We utilize your information to:
        <ul className="list-disc mx-5">
          <li className="font-semibold text-decoration-line: underline">
            We may employ Service Providers for marketing, advertising, communications,
            infrastructure, and IT services, to customize and optimize our service, process
            transactions, provide customer service, collect debts, analyze and enhance data, and
            administer surveys.
          </li>
          <li className="font-semibold text-decoration-line: underline">
            These Service Providers may access your personal or other information but are not
            authorized to use or disclose it except for providing their services.
          </li>
        </ul>
      </div>
    </section>
  );
}
